jQuery(document).ready(function($){

	$('a.edd-all-access-btn').addClass('edd-has-js');

	//When someone changes the Variable Price option for a product that only has a single file per variable price, get the updated download URL for that price ID and apply it to the download button
	$( document ).on( 'change', '.edd_aa_single_file_per_price', function( event ){

		event.preventDefault();

		var id_attr = $(this).find('input:radio:checked').prop('id');

		// Example of what is being split where Download ID = 19, Price ID = 1, and Form Number = 2: edd_price_option_19_1-2
		var id_parts = id_attr.split( '_' );
		var download_id = id_parts[3];
		var price_id_file_id = id_parts[4].split( '-' );
		var price_id = price_id_file_id[0];
		var file_id = 'single_file_per_price';

		// The can be multiple purchase forms on a single page for the same product. They are appended (by EDD core) with the form number using a "-X" where X = the form number.
		var form_helper_var = id_attr.split( '-' );
		var form_number = form_helper_var[1] ? '-' + form_helper_var[1] : '';

		// The actual HTML Form ID that contains the price ID that was just changed by the user
		var form_id_attr = '#edd_purchase_' + download_id + form_number;

		// Show the loading animation on the purchase/download button temporarily
		$( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').css( 'position', 'relative' );

		// Hide the old button
		$( form_id_attr + ' .edd-all-access-btn span, ' + form_id_attr + ' .edd-add-to-cart span, ' + form_id_attr + ' .edd_go_to_checkout span').css( 'opacity', '0' );

		// Store the old HTML so we can add our loader to it
		edd_all_access_current_purchase_html = $( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').html();

		// Add the old HTML and the loader to the button
		$( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').html( edd_all_access_current_purchase_html + '<span class="edd-all-access-loading edd-loading"><span class="screen-reader-text">' + edd_all_access_vars.loading_text + '</span></span>' );

		// Make it visible
		$( form_id_attr + ' .edd-all-access-loading').css( 'opacity', '1' );

		//Set up the PostData we'll use on the PHP side.
		var postData = {
			action: 'edd_all_access_update_download_url',
			edd_all_access_download_id: download_id,
			edd_all_access_price_id: price_id,
			edd_all_access_file_id: file_id,
		}

		//Run the ajax
		$.ajax({
			type: "POST",
			data: postData,
			dataType:"json",
			url: edd_all_access_vars.ajaxurl,
			success: function (response) {

				if ( response.success ){

					var new_purchase_form = $( response.button_html );
					var edd_purchase_submit_wrapper = $( '.edd_purchase_submit_wrapper', new_purchase_form );

					// Get any inline CSS styles added to the submit wrapper so we can add them back after replacing the button
					var edd_purchase_submit_wrapper_inline_style = $( form_id_attr + ' .edd_purchase_submit_wrapper' ).attr( 'style' );

					// Replace the edd_purchase_submit_wrapper with the one we got back from the ajax call
					$( form_id_attr + ' .edd_purchase_submit_wrapper' ).replaceWith( edd_purchase_submit_wrapper[0] );

					// Re-Add the inline CSS that pre-existed on the edd_purchase_submit_wrapper before we replaced it (just now)
					$( form_id_attr + ' .edd_purchase_submit_wrapper' ).attr( 'style', edd_purchase_submit_wrapper_inline_style );

					// Add the edd-has-js class to the new button
					$( form_id_attr + ' .edd_purchase_submit_wrapper > a' ).addClass( 'edd-has-js' );

					// Hide the other "no javascript" input button
					$( '.edd-no-js' ).hide();

					// Remove the loader we temporarily added
					//$( form_id_attr + ' .edd-all-access-loading' ).remove();
				}
				else{
					console.log( 'Fail: ' + response );
				}

			}
		}).fail(function (data) {
			console.log( data);
		});


	});

	//When someone changes the Variable Price option for a product which has multiple files per variable/single price, get the updated download URL for that price ID and apply it to the download button
	$( document ).on( 'change', '.edd_aa_multiple_files_per_price', function( event ){

		event.preventDefault();

		var id_attr = $(this).find('input:radio:checked').prop('id');

		// Example of what is being split where Download ID = 19, Price ID = 1, File ID = 3, and Form Number = 2: edd_aa_file_option_1790_0_2-2
		var id_parts = id_attr.split( '_' );
		var download_id = id_parts[4];
		var price_id = id_parts[5];
		var file_id = id_parts[6].split( '-' );
		var file_id = file_id[0];
		
		// The can be multiple purchase forms on a single page for the same product. They are appended (by EDD core) with the form number using a "-X" where X = the form number.
		var form_helper_var = id_attr.split( '-' );
		var form_number = form_helper_var[1] ? '-' + form_helper_var[1] : '';

		// The actual HTML Form ID that contains the price ID that was just changed by the user
		var form_id_attr = '#edd_purchase_' + download_id + form_number;

		// Show the loading animation on the purchase/download button temporarily
		$( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').css( 'position', 'relative' );

		// Hide the old button
		$( form_id_attr + ' .edd-all-access-btn span, ' + form_id_attr + ' .edd-add-to-cart span, ' + form_id_attr + ' .edd_go_to_checkout span').css( 'opacity', '0' );

		// Store the old HTML so we can add our loader to it
		edd_all_access_current_purchase_html = $( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').html();

		// Add the old HTML and the loader to the button
		$( form_id_attr + ' .edd-all-access-btn, ' + form_id_attr + ' .edd-add-to-cart, ' + form_id_attr + ' .edd_go_to_checkout').html( edd_all_access_current_purchase_html + '<span class="edd-all-access-loading edd-loading"><span class="screen-reader-text">' + edd_all_access_vars.loading_text + '</span></span>' );

		// Make it visible
		$( form_id_attr + ' .edd-all-access-loading').css( 'opacity', '1' );

		//Set up the PostData we'll use on the PHP side.
		var postData = {
			action: 'edd_all_access_update_download_url',
			edd_all_access_download_id: download_id,
			edd_all_access_price_id: price_id,
			edd_all_access_file_id: file_id,
		}

		//Run the ajax
		$.ajax({
			type: "POST",
			data: postData,
			dataType:"json",
			url: edd_all_access_vars.ajaxurl,
			success: function (response) {

				if ( response.success ){

					var new_purchase_form = $( response.button_html );
					var edd_purchase_submit_wrapper = $( '.edd_purchase_submit_wrapper', new_purchase_form );

					// Get any inline CSS styles added to the submit wrapper so we can add them back after replacing the button
					var edd_purchase_submit_wrapper_inline_style = $( form_id_attr + ' .edd_purchase_submit_wrapper' ).attr( 'style' );

					// Replace the edd_purchase_submit_wrapper with the one we got back from the ajax call
					$( form_id_attr + ' .edd_purchase_submit_wrapper' ).replaceWith( edd_purchase_submit_wrapper[0] );

					// Re-Add the inline CSS that pre-existed on the edd_purchase_submit_wrapper before we replaced it (just now)
					$( form_id_attr + ' .edd_purchase_submit_wrapper' ).attr( 'style', edd_purchase_submit_wrapper_inline_style );

					// Add the edd-has-js class to the new button
					$( form_id_attr + ' .edd_purchase_submit_wrapper > a' ).addClass( 'edd-has-js' );

					// Hide the other "no javascript" input button
					$( '.edd-no-js' ).hide();

					// Remove the loader we temporarily added
					//$( form_id_attr + ' .edd-all-access-loading' ).remove();
				}
				else{
					console.log( 'Fail: ' + response );
				}

			}
		}).fail(function (data) {
			console.log( data);
		});


	});

});
